<script>
export default {
	created() {
		this.render();
	},
	methods: {
		render(createElement) {
			return createElement('style', this.$slots.default);
		},
	},

};
</script>
